module.exports = __webpack_public_path__ + "static/mapping-92144bb6fed08dc9bb5522c96781138b.jpg";